import * as React from 'react';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import {
  FormControl,
  MenuItem,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import withStyles, {
  StyleRulesCallback,
  WithStyles
} from '@material-ui/core/styles/withStyles';

import { Grid } from '@material-ui/core';

import { HistogramChart, BinLegend, HistogramRanges } from './';
import { calculateBins, BinCalculationMode, Histogram } from '../utils';

const styles: StyleRulesCallback = theme => ({
  content: {
    width: 800,
    padding: '12px 36px 24px',
    display: 'flex',
    flexDirection: 'row'
  },
  table: {
    border: '1px solid rgba(224, 224, 224, 1)'
  },
  color: {
    width: 16,
    height: 16,
    border: '1px solid #888'
  }
});

interface Props {
  onClose: () => void;
  onSubmit: (bins: NdviRasterBins) => void;
  open: boolean;
  bins?: NdviRasterBins | null;
  histogram?: Histogram | null;
  totalArea?: number | null;
}

interface State {
  bins?: NdviRasterBins | null;
  resetCount: number;
}

class EditBinsDialog extends React.Component<Props & WithStyles, State> {
  constructor(props: Props & WithStyles) {
    super(props);
    this.state = { bins: props.bins, resetCount: 0 };
  }

  componentWillReceiveProps(props: Props) {
    if (props.bins !== this.props.bins) {
      this.setState({ bins: props.bins });
    }
  }

  handleSelectBins = (binCount: number, histogram: Histogram) => {
    this.setState({
      bins: calculateBins('byquantity', histogram.data, histogram.domain, 'heatmap', binCount),
      resetCount: this.state.resetCount + 1
    });
  };

  handleResetBins = (
    mode: BinCalculationMode,
    histogram: Histogram,
    bins: NdviRasterBins
  ) => {
    this.setState({
      bins: calculateBins(mode, histogram.data, histogram.domain, 'heatmap', bins.length),
      resetCount: this.state.resetCount + 1
    });
  };

  renderChart(histogram: Histogram, bins: NdviRasterBins) {
    return (
      <HistogramChart
        height={335}
        width="100%"
        histogram={histogram}
        bins={bins}
      />
    );
  }

  renderValid(histogram: Histogram, bins: NdviRasterBins, totalArea: number) {
    const { classes } = this.props;
    const { resetCount } = this.state;
    return (
      <>
        <DialogContent className={classes.content}>
          <Grid container={true} spacing={16}>
            <Grid item={true} md={7}>
              {this.renderChart(histogram, bins)}
              <HistogramRanges
                key={resetCount}
                bins={bins}
                onChange={newBins => this.setState({ bins: newBins })}
              />
            </Grid>
            <Grid item={true} md={5}>
              <FormControl fullWidth={true}>
                <InputLabel htmlFor="bins-amount">
                  Cantidad de intervalos
                </InputLabel>
                <Select
                  value={bins.length}
                  onChange={e =>
                    this.handleSelectBins(
                      parseInt(e.target.value, 10),
                      histogram
                    )
                  }
                  inputProps={{ id: 'bins-amount' }}
                  fullWidth={true}
                >
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={6}>6</MenuItem>
                  <MenuItem value={7}>7</MenuItem>
                </Select>
              </FormControl>

              <BinLegend
                dense={true}
                bins={bins}
                histogram={histogram}
                totalArea={totalArea}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div style={{ marginRight: 'auto' }}>
            <Button
              color="primary"
              onClick={() =>
                this.handleResetBins('byquantity', histogram, bins)
              }
            >
              distribuir x puntos
            </Button>
            <Button
              color="primary"
              onClick={() => this.handleResetBins('byscale', histogram, bins)}
            >
              distribuir x escala
            </Button>
          </div>
          <Button onClick={this.props.onClose}>Cancelar</Button>
          <Button color="primary" onClick={() => this.props.onSubmit(bins)}>
            Aplicar
          </Button>
        </DialogActions>
      </>
    );
  }

  render() {
    const { open, onClose, histogram, totalArea } = this.props;
    const { bins } = this.state;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onBackdropClick={onClose}
        onEscapeKeyDown={onClose}
        maxWidth={false}
      >
        <DialogTitle>Editar Intervalos de NDVI</DialogTitle>
        {histogram &&
          bins &&
          totalArea &&
          this.renderValid(histogram, bins, totalArea)}
      </Dialog>
    );
  }
}

export default withStyles(styles)(EditBinsDialog);



// WEBPACK FOOTER //
// ./src/components/EditBinsDialog.tsx